import {
  IScrollOptions,
  IOptions,
  IScrollDistanceOptions,
  ICanScroll
} from './types'
import { calculateScrollOffset, getCanScroll } from './utils'
import { easeOutSine } from './easings'

const defaultOptions: IOptions = {
  easing: easeOutSine,
  duration: 250,
  axis: 'horizontal'
}

function scroll(el: HTMLElement, endPosition: number, options: IScrollOptions) {
  const { easing, duration } = options

  const startPosition = el.scrollLeft
  let startTime
  // Dont bother to animate if duration is 0
  if (duration === 0) {
    el.scrollLeft = endPosition
    return
  }
  function tick() {
    const elapsed = Date.now() - startTime
    el.scrollLeft = easing(elapsed, startPosition, endPosition, duration)

    if (elapsed < duration) requestAnimationFrame(tick)
  }

  startTime = Date.now()
  tick()
}

const scrollIntoView = (
  target: HTMLElement,
  container: HTMLElement,
  options: IOptions = defaultOptions
) => {
  options = { ...defaultOptions, ...options }

  const { easing, duration } = options
  const distance = calculateScrollOffset(
    target,
    container,
    options && options.toLeft,
    options && options.offset
  )

  scroll(container, distance, { easing, duration })
}

const defaultScrolLDistanceOptions: IScrollDistanceOptions = {
  easing: easeOutSine,
  duration: 250,
  axis: 'horizontal',
  direction: 'left'
}

const scrollADistance = (
  container: HTMLElement,
  distance: number | null,
  options: IScrollDistanceOptions = defaultScrolLDistanceOptions
): ICanScroll => {
  options = { ...defaultScrolLDistanceOptions, ...options }
  const { width } = container.getBoundingClientRect()

  // if distance === null we should scroll one container width
  if (distance === null) {
    distance = width - 220
  }

  const { easing, duration } = options
  const distanceToScroll = options.direction === 'right' ? distance : -distance

  // must calculate this before actual scrolling takes place, because race conditions
  const canScroll = getCanScroll(
    container.scrollLeft,
    width,
    container.scrollWidth,
    distanceToScroll
  )

  scroll(container, distanceToScroll, {
    easing,
    duration
  })

  return canScroll
}

export { scrollIntoView, scrollADistance }
